angular
	.module("exploitation")
	.factory("EitiDisruptionsService", ["$http", "ENV", function($http, ENV) {
		/**
		 * API
		 */
		return {
			addDisruption: addDisruption,
			deleteDisruption: deleteDisruption,
			diffuse: diffuse,
			edit: editDisruption,
			getDisruption: getDisruption,
			getAll: getAllDisruptions,
			getCurrentWeekDisruptions: getCurrentWeekDisruptions,
			getCurrentMonthDisruptions: getCurrentMonthDisruptions,
			getCurrentYearDisruptions: getCurrentYearDisruptions,
			getLast30DaysDisruptions: getLast30DaysDisruptions
		};

		/**
		 * Gets all disruptions
		 * @returns {*}
		 */
		function getAllDisruptions(active, useCache) {
			return $http.get(ENV.API_URL + "/disruptions", {
				cache: useCache ? useCache : false
			});
		}

		/**
		 * Gets disruptions started in the last 30 days
		 */
		function getLast30DaysDisruptions() {
			return getLastXDaysDisruptions(30);
		}

		/**
		 * Gets disruptions started in the last nbDays days
		 */
		function getLastXDaysDisruptions(nbDays) {
			var d = new Date();
			d.setDate(d.getDate() - nbDays);
			return getStartingFromDisruptions(d);
		}

		/**
		 * Gets disruptions started this week
		 */
		function getCurrentWeekDisruptions() {
			return getStartingFromDisruptions(getMonday(new Date()));
		}

		/**
		 * Gets disruptions started this month
		 */
		function getCurrentMonthDisruptions() {
			return getStartingFromDisruptions(getStartOfMonth());
		}

		/**
		 * Gets disruptions started this year
		 */
		function getCurrentYearDisruptions() {
			return getStartingFromDisruptions(getStartOfYear());
		}

		/**
		 * Gets disruptions starting from the specified date
		 * @param starting Disruption start date
		 */
		function getStartingFromDisruptions(starting) {
			const params = "startingFrom=" + encodeURIComponent(starting);
			return $http.get(ENV.API_URL + "/disruptions?" + params);
		}

		/**
		 * Updates a disruption
		 * @param disruption
		 * @returns {*|HttpPromise}
		 */
		function editDisruption(disruption, file, shouldKeepImage) {
			formatDates(disruption);

			delete disruption.organization;
			delete disruption.imgFileName;
			delete disruption.imgFileBinary;



			let fd = new FormData();
			if (file !== undefined){
				fd.append("file", file);
			}

			fd.append("disruption",angular.toJson(disruption));
			fd.append("shouldKeepImage",shouldKeepImage);

			return $http.put(ENV.API_URL + "/disruptions/" + disruption.id, fd, {
				transformRequest: angular.identity,
				headers: {"Content-Type": undefined}
			});

		}

		/**
		 * Gets a disruption by its id
		 *
		 * @param id l'Id du company à récupérer.
		 * @returns {*}
		 */
		function getDisruption(id) {
			return $http.get(ENV.API_URL + "/disruptions/" + id);
		}

		/**
		 * Deletes a disruption.
		 *
		 * @param disruptionId Id of the disruption to remove
		 * @returns {HttpPromise|*|{display}}
		 */
		function deleteDisruption(disruptionId) {
			return $http.delete(ENV.API_URL + "/disruptions/" + disruptionId);
		}

		function diffuse(disruptionId) {
			return $http.post(ENV.API_URL + "/disruptions/diffusion/" + disruptionId);
		}

		/**
		 * Creates a new disruption
		 * @param company
		 * @returns {*|HttpPromise}
		 */
		function addDisruption(disruption, file, shouldKeepImage) {
			formatDates(disruption);


			let fd = new FormData();
			if (file !== undefined){
				fd.append("file", file);
			}
			fd.append("shouldKeepImage",shouldKeepImage);
			fd.append("disruption",angular.toJson(disruption));


			return $http.post(ENV.API_URL + "/disruptions", fd, {
				transformRequest: angular.identity,
				headers: {"Content-Type": undefined}
			});
		}

		/**
		 * Formatte les dates en timestamp pour une perturbation
		 */
		function formatDates(disruption) {
			if (disruption) {
				if (disruption.startDateTime) {
					disruption.startDateTime = new Date(
						disruption.startDateTime
					).getTime();
				}
				if (disruption.endDateTime) {
					disruption.endDateTime = new Date(
						disruption.endDateTime
					).getTime();
				}

				if (disruption.publicationStartDateTime) {
					disruption.publicationStartDateTime = new Date(
						disruption.publicationStartDateTime
					).getTime();
				}

				if (disruption.publicationEndDateTime) {
					disruption.publicationEndDateTime = new Date(
						disruption.publicationEndDateTime
					).getTime();
				}

			}
		}

		/**
		 * Returns the monday date for the week of the specificed date d
		 */
		function getMonday(d) {
			d = new Date(d);
			var day = d.getDay(),
				diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
			toMidnight(d);
			return new Date(d.setDate(diff));
		}

		/**
		 * Returns the date of the start of the current month
		 */
		function getStartOfMonth() {
			var date = new Date();
			var startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
			return toMidnight(startOfMonth);
		}

		/**
		 * Returns the date of the start of the current year
		 */
		function getStartOfYear() {
			var date = new Date();
			var startOfYear = new Date(date.getFullYear(), 0, 1);
			return toMidnight(startOfYear);
		}

		/**
		 * Changes the date to midnight time
		 */
		function toMidnight(date) {
			date.setHours(0);
			date.setMinutes(0);
			date.setSeconds(0);
			return date;
		}
	}]);
